/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Ellipse = createLucideIcon("ellipse", [
  ["ellipse", { cx: "12", cy: "12", rx: "10", ry: "6", key: "swdkt4" }]
]);

export { Ellipse as default };
//# sourceMappingURL=ellipse.js.map
